export const TENANT_ROLES = ['owner', 'admin', 'viewer'] as const;
export const TENANT_STATUSES = ['trialing', 'active', 'suspended'] as const;
export const DEVICE_STATUSES = ['online', 'offline', 'pairing', 'revoked'] as const;
export const LOCKDOWN_ORDER = { none: 0, pwa: 1, shell: 2 } as const;

export type TenantRole = typeof TENANT_ROLES[number];
export type TenantStatus = typeof TENANT_STATUSES[number];
export type DeviceStatus = typeof DEVICE_STATUSES[number];